import { ReactNode, useCallback } from 'react';

import { Link, LinkProps } from 'components/tools';
import { Grid, Icon } from 'components/ui/general';

import styles from './Breadcrumbs.module.scss';

export type BreadcrumbsProps = {
  crumbs: {
    label?: ReactNode;
    to?: LinkProps['to'];
  }[];
};

export const Breadcrumbs = ({ crumbs }: BreadcrumbsProps) => {
  const renderCrumbs = useCallback(() => {
    return crumbs.map(({ label = '...', to }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} className={styles.crumb}>
        {index === crumbs.length - 1 || !to ? (
          <div className={styles.current}>{label}</div>
        ) : (
          <>
            <Link to={to} className={styles.link}>
              {label}
            </Link>
            <Icon className={styles.icon} name="angle-right" />
          </>
        )}
      </div>
    ));
  }, [crumbs]);

  if (crumbs?.length) {
    return <Grid align="middle">{renderCrumbs()}</Grid>;
  }

  return null;
};
